import React from "react";
import Button from "@material-ui/core/Button";
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { 
  makeStyles,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import Container from "@material-ui/core/Container";
import Copyright from "Components/Copyright";
import useAuth from "Hooks/useAuth";
import ReCAPTCHA from "react-google-recaptcha";
import queryString from "query-string";

import MuiAlert from "@material-ui/lab/Alert";
import dayjs from "dayjs";
dayjs.locale("ja");
import useError from "Hooks/useError";
import { message } from "constants/message";
import googleAnalytics from "fuction/googleAnalytics";

import Axios from "axios";

const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    fontSize: "2.5em",
    color: "#556cd6",
  },
  paper: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    marginTop: theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  loginPaper: {
    marginBottom: theme.spacing(4),
    width: "301px",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  infoTitle: {
    marginBottom: theme.spacing(1),
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  tableBody: {
    display: "block",
    height: "265px",
    overflowY: "scroll",
  },
  infoPaper: {
    width: "601px",
  },
  content: {
    width: "493px",
  },
  validFrom: {
    width: "108px",
  },
  toast: {
    width: "100%",
    margin: theme.spacing(3, 0, 2),
  },
  messsageWrapper: {
    marginTop: theme.spacing(1),
  },
}));

export default function SignIn(props) {
  const stateError = useError();
  const messages = message();
  const auth = useAuth();

  const [mail, setMail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [recaptcha, setRecaptcha] = React.useState("");
  const [user, setUser] = React.useState({});
  const [token, setToken] = React.useState("");
  const [informations, setInformations] = React.useState([]);
  const { status } = queryString.parse(props.location.search);

  React.useEffect(() => {
    // ログイン済みの場合は初期画面へ遷移
    if (localStorage.getItem("token")) {
      // ログインユーザのプランにより遷移先を振り分け
      if (JSON.parse(localStorage.getItem("user")).contract_type != "ruby") {
        props.history.push("/dashboard");
      } else {
        props.history.push("/media/dashboard");
      }
    }

    // タイトル変更
    document.title = "Buzz Finder";

    getInformations();

    stateError.initialize();
    switch (status) {
      case "201":
        alert(messages.signIn.passwordReset);
        break;
      case "401":
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.signIn.authorization,
          },
        });
        break;
      case "404":
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.signIn.authorization,
          },
        });
        break;
      default:
        break;
    }
  }, []);

  React.useEffect(() => {
    if (!token) return;

    // ログインユーザ詳細を取得
    Axios({
      method: "POST",
      url: `config/${auth.state.user.account_id}/account`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      data: {
        "attrs": [
          "contract_type",
          "options",
        ]        
      },
    }).then(result => {
      user.contract_type = result.data.data.contract_type;
      user.options = result.data.data.options;
      
      auth.login({
        user: user,
        token: token,
      });

      // ログインユーザのプランにより遷移先を振り分け
      if (result.data.data.contract_type != "ruby") {
        props.history.push("/dashboard");
      } else {
        props.history.push("/media/dashboard");
      }
    }).catch(errors => {
      const isError = true;
      let errorMsg = messages.signIn.authorization;
      stateError.dispatch({
        type: "set",
        payload: {
          isError: isError,
          errorMsg: errorMsg,
        },
      });
    });
  }, [token]);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname);
  }, [props.location.pathname]);

  // お知らせ一覧を取得
  const getInformations = () => {
    Axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;

    Axios({
      method: "GET",
      url: "information",
    }).then(result => {
      setInformations(result.data.data);
    });
  }

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell className={classes.validFrom}>{dayjs(row.valid_from).format("YYYY/MM/DD")}</TableCell>
          <TableCell className={classes.content}>
            {row.url ? (
              <a href={row.url} target="_blank" onClick={(e) => handleInfoLinkClick(e, row)}>{row.content}</a>
            ) : (
              row.content
            )}
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const handleInfoLinkClick = (e, row) => {
    e.preventDefault();
    // リンク付きお知らせ既読登録
    registRead(row);
    window.open(row.url, '_blank');
  };

  const registRead = (row) => {
    let knownInfomations = getKnownInfomations();
    knownInfomations.link = {...knownInfomations?.link, [row.id]: Date.now()};
    localStorage.setItem("informations", JSON.stringify(knownInfomations));
  }

  // 既読お知らせIDを取得する
  const getKnownInfomations = () => {
    let knownInfomations = {};
    if (localStorage.getItem("informations")) {
      knownInfomations = JSON.parse(localStorage.getItem("informations"));
    }
    return knownInfomations;
  }

  const handleSubmit = async (e) => {
    
    e.preventDefault();
    Axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
    
    await Axios({
      method: "POST",
      url: "authentication/login",
      data: {
        email: mail,
        password: password,
        "g-recaptcha-response": recaptcha,
      },
    }).then(result => {
      setUser(result.data.data.user);
      setToken(result.data.data.bearer_token);
    }).catch(errors => {
      const isError = true;
      let errorMsg = "";
      // レスポンスの内容によってメッセージを出し分け
      if (errors.response.data.errors) {
        errorMsg = messages.errorMsg.continuousLoginErr;
      } else {
        errorMsg = messages.errorMsg.requestLoginErr;
      }
      stateError.dispatch({
        type: "set",
        payload: {
          isError: isError,
          errorMsg: errorMsg,
        },
      });

      console.error("request err", errors);
      console.error("errors.response", errors.response);

      // recaptcha をリセット
      window.grecaptcha.reset();
      setRecaptcha("");
      throw errors;
    });
  };

  const onChange = (value) => {
    setRecaptcha(value);
  };

  const onError = () => {
    stateError.dispatch({
      type: "set",
      payload: {
        isError: true,
        errorMsg: messages.validation.common,
      },
    });
  };

  const classes = useStyles();

  return (
    <Container component="main">
      <h1 className={classes.title}>Buzz Finder</h1>
      <div className={classes.paper}>
        <div className={classes.loginPaper}>
          <Typography component="h1" variant="h5">
            ログイン
          </Typography>
          <ValidatorForm 
            className={classes.form} 
            onSubmit={handleSubmit} 
            onError={onError}
            method="post"
          >
            <TextValidator
              variant="outlined"
              margin="normal"
              fullWidth
              id="email"
              label="メールアドレス*"
              autoFocus
              value={mail}
              onChange={(event) => {
                setMail(event.target.value);
              }}
              validators={['required', 'isEmail']}
              errorMessages={[messages.validation.required, messages.validation.isEmail]}
            />
            <TextValidator
              variant="outlined"
              margin="normal"
              fullWidth
              label="パスワード*"
              type="password"
              id="password"
              value={password}
              onChange={(event) => {
                setPassword(event.target.value);
              }}
              validators={['required']}
              errorMessages={[messages.validation.required]}
            />
            <ReCAPTCHA
              sitekey="6Lc6iMIZAAAAAMJDC7Sw78HcKqw76XmCZvtQFmPH"
              onChange={onChange}
            />
            {stateError.state.isError && (
              <div className={classes.messsageWrapper}>
                <MuiAlert
                  elevation={6}
                  variant="filled"
                  severity="error"
                  className={classes.toast}
                >
                  {stateError.state.errorMsg}
                </MuiAlert>
              </div>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              disabled={!recaptcha}
            >
              ログイン
            </Button>
            <Grid container>
              <Grid item xs>
                <Link href="/password_reset/request" variant="body2">
                  パスワードを忘れた方はこちら
                </Link>
              </Grid>
            </Grid>
          </ValidatorForm>
        </div>
        <div className={classes.infoPaper}>
          <Typography component="h1" variant="h5" className={classes.infoTitle}>
            お知らせ
          </Typography>
          <Table className={classes.table}>
            <TableBody className={informations.length > 5 ? classes.tableBody : null}>
              {informations.length > 0 ? informations.map(
                function (row, index) {
                  return <Row key={index} index={index+1} row={row} />
                }
              ) : (
                <TableRow>
                  <TableCell align="center">現在お知らせはありません</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
